module.exports = __webpack_public_path__ + "img/header-memoireRingsHalfSetMemories.87c3ce9.webp";